/** Amaron dashboard created-at two-hour heat map formatters. */

const HOURS_PER_DAY = 24;
const HOURS_PER_SLOT = 2;

function normalizeHour24(hour24: number): number {
    return ((hour24 % HOURS_PER_DAY) + HOURS_PER_DAY) % HOURS_PER_DAY;
}

function formatHour12h(hour24: number): string {
    const normalized = normalizeHour24(hour24);
    const displayHour = normalized % 12 === 0 ? 12 : normalized % 12;
    const meridiem = normalized < 12 ? "am" : "pm";
    return `${displayHour}${meridiem}`;
}

export function formatAmaronCreatedAtTwoHourHeatMapColumnKey(hour24: number): string {
    const slotStartHour = Math.floor(normalizeHour24(hour24) / HOURS_PER_SLOT) * HOURS_PER_SLOT;
    return `${formatHour12h(slotStartHour)} - ${formatHour12h(slotStartHour + HOURS_PER_SLOT)}`;
}

export const AMARON_CREATED_AT_TWO_HOUR_HEATMAP_COLUMN_KEYS: ReadonlyArray<string> = Array.from(
    {length: HOURS_PER_DAY / HOURS_PER_SLOT},
    (_, slotIndex) => formatAmaronCreatedAtTwoHourHeatMapColumnKey(slotIndex * HOURS_PER_SLOT),
);

export const AMARON_BOOKING_TIME_SLOT_HEATMAP_COLUMN_KEYS = [
    "9 AM - 11 AM",
    "11 AM - 1 PM",
    "1 PM - 3 PM",
    "3 PM - 5 PM",
] as const;

function hour12To24(hour: number, meridiem: string): number | null {
    if (hour < 1 || hour > 12) {
        return null;
    }
    const normalizedMeridiem = meridiem.toUpperCase();
    if (normalizedMeridiem !== "AM" && normalizedMeridiem !== "PM") {
        return null;
    }
    return hour % 12 + (normalizedMeridiem === "PM" ? 12 : 0);
}

function readBookingSlotStartHour(rawValue: string): number | null {
    const displayLabelMatch = rawValue.trim().match(/^(\d{1,2})\s*(AM|PM)\s*-\s*\d{1,2}\s*(AM|PM)$/i);
    if (displayLabelMatch !== null) {
        return hour12To24(Number(displayLabelMatch[1]), displayLabelMatch[2] ?? "");
    }

    // Retained defensively for environments where the legacy migration has not run yet.
    const legacyDatePrefixedMatch = rawValue.trim().match(
        /^\d{4}-\d{2}-\d{2}\s+([01]\d|2[0-3]):\d{2}-([01]\d|2[0-3]):\d{2}$/,
    );
    if (legacyDatePrefixedMatch !== null) {
        return Number(legacyDatePrefixedMatch[1]);
    }

    return null;
}

export function formatAmaronBookingTimeSlotHeatMapColumnKey(rawValue: string): string | null {
    const startHour = readBookingSlotStartHour(rawValue);
    if (startHour === null) {
        return null;
    }
    if (startHour >= 9 && startHour < 11) {
        return AMARON_BOOKING_TIME_SLOT_HEATMAP_COLUMN_KEYS[0];
    }
    if (startHour >= 11 && startHour < 13) {
        return AMARON_BOOKING_TIME_SLOT_HEATMAP_COLUMN_KEYS[1];
    }
    if (startHour >= 13 && startHour < 15) {
        return AMARON_BOOKING_TIME_SLOT_HEATMAP_COLUMN_KEYS[2];
    }
    if (startHour >= 15 && startHour < 17) {
        return AMARON_BOOKING_TIME_SLOT_HEATMAP_COLUMN_KEYS[3];
    }
    return null;
}
